<template>  
  <div class="sellservicerequset">
    <XR-head titleText="申请售后服务"></XR-head>
    <mu-list class="request-form">
      <mu-list-item :title="reasonText" @click="openBottomSheet()">        
        <mu-icon slot="right" value=":fa fa-detail"/>
        <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">
          <mu-list>
            <mu-sub-header>请选择申请原因</mu-sub-header>
            <mu-list-item title="没有原因，就是要退货" @click="sexSelectClick('没有原因，就是要退货')" />
            <mu-list-item title="超过48小时未发货" @click="sexSelectClick('超过48小时未发货')" />
            <mu-list-item title="与图片不相符" @click="sexSelectClick('与图片不相符')" />
            <mu-list-item title="质量太差" @click="sexSelectClick('质量太差')" />
          </mu-list>
        </mu-bottom-sheet>
      </mu-list-item>
    </mu-list>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33">
      <div class="remark">      
        <mu-text-field  label="问题描述" hintText="请您在此描述问题" v-model="requestInfo.ReasonDesc" multiLine :rows="3" :rowsMax="6" fullWidth :maxLength="100" />
      </div>
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="button-row">
        <mu-raised-button label="确 定" class="submit" primary fullWidth @click="sellServiceOrderRequest()" />
      </mu-col>
    </mu-row>
    
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bottomSheet: false,
      dialog: false,
      reasonText : '请选择申请原因',
      requestInfo:{
        OrderType: this.$route.query.orderType,
        ServiceType:this.$route.query.sellServiceType,
        ItemId:this.$route.query.itemId,
        Reason:'',
        ReasonDesc:''
      },
      isRequestIng : false
    }
  },
  methods: { 
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    sexSelectClick(textVal){
      this.requestInfo.Reason = textVal
      this.reasonText = textVal
      this.closeBottomSheet();
    },
    sellServiceOrderRequest(){
      if(!this.isRequestIng){
        this.isRequestIng = true
        var ths = this;   
        ths.$post(
          "/Shop/RetailServer/SellServiceOrderRequest",
          JSON.stringify(this.requestInfo)
        ).then(function(res) {
          ths.isRequestIng = false
          if(!res.IsSuccess){     
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{    
            ths.$refs.XRtoast.success(res.Msg, true)
          }
        });
      }else{
        ths.$refs.XRtoast.failed('正在提交，请稍等...', true)
      }
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>

<style>
.sellservicerequset .request-form{
  background: white;
}
.sellservicerequset .remark{
  background: white;
  margin-top: 10px;
  padding: 10px;
}
.sellservicerequset .button-row{  
  padding: 40px 20px 0 20px;
}
.sellservicerequset .submit{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sellservicerequest.vue